var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonObject, JsonProperty } from 'json2typescript';
export var RequestOrigin;
(function (RequestOrigin) {
    RequestOrigin["UI"] = "UI";
    RequestOrigin["AdminAPI"] = "Admin API";
    RequestOrigin["CLI"] = "CLI";
    RequestOrigin["GitHubWebhook"] = "GitHub Webhook";
})(RequestOrigin || (RequestOrigin = {}));
export var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["Created"] = "created";
    DeploymentStatus["Successful"] = "successful";
    DeploymentStatus["SuccessfulWithWarning"] = "successfulWithWarning";
    DeploymentStatus["Failed"] = "failed";
    DeploymentStatus["Pending"] = "pending";
})(DeploymentStatus || (DeploymentStatus = {}));
export var AppConfig;
(function (AppConfig) {
    AppConfig["Version20180301"] = "20180301";
    AppConfig["Version20200603"] = "20200603";
    AppConfig["Version20210101"] = "20210101";
})(AppConfig || (AppConfig = {}));
var Deployment = (function () {
    function Deployment(partial) {
        this.id = '';
        this.appId = '';
        this.draftId = undefined;
        this.userId = undefined;
        this.deployedAt = 0;
        this.origin = RequestOrigin.UI;
        this.commit = '';
        this.status = DeploymentStatus.Pending;
        this.statusErrorMessage = '';
        this.diffUrl = '';
        this.name = undefined;
        this.remoteLocation = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id'),
        __metadata("design:type", Object)
    ], Deployment.prototype, "id", void 0);
    __decorate([
        JsonProperty('app_id'),
        __metadata("design:type", Object)
    ], Deployment.prototype, "appId", void 0);
    __decorate([
        JsonProperty('draft_id', String, true),
        __metadata("design:type", String)
    ], Deployment.prototype, "draftId", void 0);
    __decorate([
        JsonProperty('user_id', String, true),
        __metadata("design:type", String)
    ], Deployment.prototype, "userId", void 0);
    __decorate([
        JsonProperty('deployed_at'),
        __metadata("design:type", Object)
    ], Deployment.prototype, "deployedAt", void 0);
    __decorate([
        JsonProperty('origin'),
        __metadata("design:type", String)
    ], Deployment.prototype, "origin", void 0);
    __decorate([
        JsonProperty('commit'),
        __metadata("design:type", Object)
    ], Deployment.prototype, "commit", void 0);
    __decorate([
        JsonProperty('status'),
        __metadata("design:type", String)
    ], Deployment.prototype, "status", void 0);
    __decorate([
        JsonProperty('status_error_message'),
        __metadata("design:type", Object)
    ], Deployment.prototype, "statusErrorMessage", void 0);
    __decorate([
        JsonProperty('diff_url'),
        __metadata("design:type", Object)
    ], Deployment.prototype, "diffUrl", void 0);
    __decorate([
        JsonProperty('name', String, true),
        __metadata("design:type", String)
    ], Deployment.prototype, "name", void 0);
    __decorate([
        JsonProperty('remote_location', String, true),
        __metadata("design:type", String)
    ], Deployment.prototype, "remoteLocation", void 0);
    Deployment = __decorate([
        JsonObject('Deployment'),
        __metadata("design:paramtypes", [Object])
    ], Deployment);
    return Deployment;
}());
export { Deployment };
var DeployDraftPayload = (function () {
    function DeployDraftPayload(partial) {
        this.name = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('name', String, true),
        __metadata("design:type", String)
    ], DeployDraftPayload.prototype, "name", void 0);
    DeployDraftPayload = __decorate([
        JsonObject('DeployDraftPayload'),
        __metadata("design:paramtypes", [Object])
    ], DeployDraftPayload);
    return DeployDraftPayload;
}());
export { DeployDraftPayload };
//# sourceMappingURL=Deployment.js.map